import { useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import { Button, Link, Grid } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import "./assets/css/Login.css";
// import Logo from "./assets/images/Logo2.png";
import CircularProgress from "@mui/material/CircularProgress";
import { useStoreDollHouseMap } from "./store";
import { shallow } from "zustand/shallow";
import { sendPostRequest } from "./util";

export default function Login({ updateLoginStatus }) {
  const theme = useTheme();
  const dollhouseStore = useStoreDollHouseMap(
    (state) => ({
      updateLoginData: state.updateLoginData,
      updateFeedbackTitle: state.updateFeedbackTitle,
    }),
    shallow
  );

  const [company, setCompany] = useState("");
  const [password, setPassword] = useState("mgm123");
  const [ispasswordvalid, setPasswordvalid] = useState(false);
  const [passwordErrror, setPasswordError] = useState("");
  const [loading, setLoading] = useState(false);

  const [isnamevalid, setisnamevalid] = useState(false);
  const [namerror, setnamerror] = useState("");

  const validateField = () => {
    let valid = true;

    if (company === "") {
      setisnamevalid(true);
      setnamerror("Company Name Required.");
      valid = false;
    }

    // if (password === "") {
    //   setPasswordvalid(true);
    //   setPasswordError("Password Required.");
    //   valid = false;
    // }

    return valid;
  };

  const clearValidation = () => {
    // if (ispasswordvalid) {
    //   setPasswordvalid(false);
    //   setPasswordError("");
    // }

    if (isnamevalid) {
      setisnamevalid(false);
      setnamerror("");
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    clearValidation();
    if (!validateField()) {
      return;
    }

    setLoading(true);
    let data = {
      name: company,
      password: password,
    };
    sendPostRequest(process.env.REACT_APP_LOGIN_API, data, (error, res) => {
      if (error) {
        console.error("Error:", error);
      } else {
        setLoading(false);

        if (res.response === "error") {
          setPasswordvalid(true);
          setPasswordError("Incorrect Password.");
        } else {
          updateLoginStatus(true);
          dollhouseStore.updateLoginData(res.user_id);
          dollhouseStore.updateFeedbackTitle(res.feed_back_text);
        }
        console.log("Response:", res);
      }
    });
  };

  const handleCompanyName = (e) => {
    if (isnamevalid) {
      setisnamevalid(false);
      setnamerror("");
    }
    setCompany(e.target.value);
  };

  const handlePassword = (e) => {
    if (ispasswordvalid) {
      setPasswordvalid(false);
      setPasswordError("");
    }
    setPassword(e.target.value);
  };
  return (
    <>
      {window.innerWidth > window.innerHeight && (
        <Box className="loginBg">
          <Box
            sx={{
              py: 3,
              px: 5,
              mx: "auto",
              [theme.breakpoints.down("md")]: {
                padding: "6px 70px",
                marginTop: "-20px",
              },
            }}
            className="Login-Signup-Box"
          >
            <div className="loginLogo">
              {/* <img src={Logo} /> */}
              <img src={'/MGM/2.png'} />
            </div>
            <form onSubmit={handleSubmit}>
              <FormControl sx={{ mb: 2, width: "100%" }}>
                <p>Company Name</p>
                <TextField
                  sx={{
                    color: "black",
                    "& .MuiInputBase-input": {
                      [theme.breakpoints.down("md")]: {
                        padding: " 8.5px 14px",
                      },
                    },
                  }}
                  name="email"
                  color="primary"
                  value={company}
                  onChange={handleCompanyName}
                  error={isnamevalid}
                  helperText={namerror}
                />
              </FormControl>

              {/* <FormControl sx={{ mb: 2, width: "100%" }}>
                <p>Password</p>
                <TextField
                  sx={{
                    color: "black",
                    "& .MuiInputBase-input": {
                      [theme.breakpoints.down("md")]: {
                        padding: " 8.5px 14px",
                      },
                    },
                  }}
                  type="password"
                  error={ispasswordvalid}
                  helperText={passwordErrror}
                  value={password}
                  onChange={handlePassword}
                />
              </FormControl> */}
              <FormControl sx={{ mb: 2, width: "100%" }}>
                <Button
                  disabled={loading}
                  sx={{ flexGrow: 1 }}
                  className="btn-black"
                  type="submit"
                  variant="contained"
                >
                  Enter
                </Button>
                {loading && (
                  <CircularProgress
                    size={24}
                    sx={{
                      color: "#bda770",
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      marginTop: "-12px",
                      marginLeft: "-12px",
                    }}
                  />
                )}
              </FormControl>
            </form>
          </Box>
        </Box>
      )}
    </>
  );
}
